<template>
  <jade-box
    :title="$t('conversionTitle')"
    hasPadding
    class="flex-1"
  >
    <template>
      <dash-progress-bar
        v-for="item in conversions"
        :key="item.key"
        :value="item.percentage"
        :color="item.color"
        :precision="0"
        show-background
      >
        <payment-methods-icons
          v-if="item.leftIcon"
          :icon-name="item.leftIcon.name"
          :tooltip-list="item.leftIcon.tooltip"
          :tooltip-id="'payment-methods_info-tippy-' + item.key"
        />

        <jade-text>{{ $t(item.name) }}</jade-text>

        <conversions-icons
          v-if="item.rightIcon"
          :tooltip-list="item.rightIcon.tooltip"
          :tooltip-id="'conversion_info-tippy-' + item.key"
        />
      </dash-progress-bar>
    </template>
  </jade-box>
</template>
<script>
import { JadeBox, JadeText } from '@jade'

import PaymentMethodsIcons from '@/components/project/globals/PaymentMethodsIcons/index.vue'

import DashProgressBar from '../components/DashProgressBar/index.vue'

import ConversionManager from './conversions.manager'
import ConversionsIcons from './ConversionsTooltip.vue'

export default {
  name: 'Conversion',

  components: {
    JadeBox,
    JadeText,
    PaymentMethodsIcons,
    DashProgressBar,
    ConversionsIcons
  },

  props: {
    data: Array
  },

  computed: {
    conversions () {
      return new ConversionManager(this.data).get()
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "conversionTitle": "Índices de conversão",
    "conversion": {
      "cards": "Conversão de cartão",
      "boleto": "Conversão de boleto",
      "pix": "Conversão de pix",
      "others": "Outros",
      "cash": "Cash"
    }
  },
  "en-US": {
    "conversionTitle": "Conversions",
    "conversion": {
      "cards": "Card conversion",
      "boleto": "Boleto conversion",
      "pix": "Pix conversion",
      "others": "Others",
      "cash": "Cash"
    }
  }
}
</i18n>

<style scoped>
.dash-progress-bar {
  margin-bottom: 24px;
}
</style>
